import React from 'react'
import PropTypes from 'prop-types';
import NationalNoticeSection from "./NationalNoticeSection";


function Index(
    {
        expanded
    }) {
    return expanded && <NationalNoticeSection/>
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;